/**
 * Cart Inventory Limit
 * 
 * This script enhances the cart functionality by:
 * 1. Preventing users from incrementing beyond available inventory
 * 2. Disabling the plus button when reaching inventory limit
 * 3. Fixing the 422 error issue when attempting to update beyond inventory
 */

document.addEventListener('DOMContentLoaded', function() {
  initCartInventoryLimit();
});

function initCartInventoryLimit() {
  // Apply initial button states based on inventory
  updateAllPlusButtons();
  
  // Monitor for DOM changes that might affect the cart
  const cartItemListObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // When cart items are updated/added, we need to re-initialize
        updateAllPlusButtons();
      }
    });
  });
  
  const cartItemList = document.querySelector('[data-cart-item-list]');
  if (cartItemList) {
    cartItemListObserver.observe(cartItemList, { childList: true, subtree: true });
  }
  
  // Patch the original QuantitySelector's increaseAmount method
  patchQuantitySelector();
}

function updateAllPlusButtons() {
  // Find all cart items
  const cartItems = document.querySelectorAll('[data-cartitem]');
  
  cartItems.forEach(function(cartItem) {
    const inventoryQuantity = parseInt(cartItem.getAttribute('data-inventory-quantity'), 10);
    if (!isNaN(inventoryQuantity)) {
      const quantityInput = cartItem.querySelector('[data-quantity-input]');
      const plusButtonWrapper = cartItem.querySelector('[data-button-wrapper-plus]');
      
      if (quantityInput && plusButtonWrapper) {
        const currentQuantity = parseInt(quantityInput.value, 10);
        const incrementValue = parseInt(quantityInput.getAttribute('data-increment-value'), 10) || 1;
        
        // Disable plus button if quantity is at or above inventory limit
        if (currentQuantity >= inventoryQuantity || currentQuantity + incrementValue > inventoryQuantity) {
          plusButtonWrapper.classList.add('quantity-selector__button-wrapper--disabled');
        } else {
          plusButtonWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
        }
      }
    }
  });
}

function patchQuantitySelector() {
  // This function runs only once to patch the original methods
  document.addEventListener('click', function(e) {
    // Intercept clicks on plus buttons
    if (e.target.matches('[data-quantity-plus]') || e.target.closest('[data-quantity-plus]')) {
      const plusButton = e.target.matches('[data-quantity-plus]') ? e.target : e.target.closest('[data-quantity-plus]');
      const quantitySelector = plusButton.closest('[data-quantity-selector]');
      const cartItem = quantitySelector.closest('[data-cartitem]');
      
      if (cartItem && cartItem.hasAttribute('data-inventory-quantity')) {
        const inventoryQuantity = parseInt(cartItem.getAttribute('data-inventory-quantity'), 10);
        const quantityInput = cartItem.querySelector('[data-quantity-input]');
        const currentQuantity = parseInt(quantityInput.value, 10);
        const incrementValue = parseInt(quantityInput.getAttribute('data-increment-value'), 10) || 1;
        
        // Prevent incrementing beyond inventory
        if (currentQuantity >= inventoryQuantity || currentQuantity + incrementValue > inventoryQuantity) {
          e.preventDefault();
          e.stopImmediatePropagation();
          
          // Ensure the plus button is disabled visually
          const plusButtonWrapper = cartItem.querySelector('[data-button-wrapper-plus]');
          if (plusButtonWrapper) {
            plusButtonWrapper.classList.add('quantity-selector__button-wrapper--disabled');
          }
          
          return false;
        }
      }
    }
  }, true); // Use capture phase to intercept before original handler
  
  // Patch the input change event to prevent manual entry beyond inventory
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-quantity-input]')) {
      const quantityInput = e.target;
      const cartItem = quantityInput.closest('[data-cartitem]');
      
      if (cartItem && cartItem.hasAttribute('data-inventory-quantity')) {
        const inventoryQuantity = parseInt(cartItem.getAttribute('data-inventory-quantity'), 10);
        const currentQuantity = parseInt(quantityInput.value, 10);
        
        // Limit the quantity to inventory amount
        if (currentQuantity > inventoryQuantity) {
          quantityInput.value = inventoryQuantity;
        }
        
        // Update button states
        updateAllPlusButtons();
      }
    }
  });
}

// Add styles for disabled plus button
document.addEventListener('DOMContentLoaded', function() {
  const style = document.createElement('style');
  style.textContent = `
    .quantity-selector__button-wrapper--disabled .quantity-selector__button--plus {
      pointer-events: none;
      opacity: 0.5;
    }
  `;
  document.head.appendChild(style);
}); 